'use client';

import './gifts-total.scss';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { BlockProps } from '@sola/schema/lib/schema.ts';

type GiftsTotalProps = BlockProps & {
  totalGiftAmount?: number;
};

export const GiftsTotal: React.ComponentType<GiftsTotalProps> = ({
  totalGiftAmount: totalGiftAmountProp,
}) => {
  const { t } = useTranslation(['my', 'core']);
  const {
    actions: { getCart, goToCheckout },
    isReady,
    getGifts,
  } = useCart('actions', 'isReady', 'getGifts');

  useEffect(() => {
    if (!isReady) {
      getCart();
    }
  }, [getCart, isReady]);

  const { total } = getGifts();
  const totalGiftAmount = totalGiftAmountProp ?? total;
  const isCheckoutDisabled = totalGiftAmount <= 0;

  return (
    <section className="component GiftsTotal component--no-header">
      <div className="container border-t border-gray-300 py-comfy-sm">
        <div className="flex items-center justify-between gap-snug-lg">
          <dl className="m-none flex flex-col gap-snug-lg">
            <dt className="GiftsTotal__label label-lg label-neutral-mild">
              {t('my:giftsTotal.totalGift', 'Total Gift')}
            </dt>
            <dd className="GiftsTotal__amount m-none heading-sm">
              {t('core:numbers.currencyCustom', {
                amount: totalGiftAmount,
              })}
            </dd>
          </dl>

          <ButtonStyle
            variant="primary"
            size="md"
            disabled={isCheckoutDisabled}
          >
            <button
              type="button"
              disabled={isCheckoutDisabled}
              onClick={() => {
                goToCheckout();
              }}
            >
              {t('my:giftsTotal.reviewAndCheckout', 'Review & Checkout')}
            </button>
          </ButtonStyle>
        </div>
      </div>
    </section>
  );
};
